import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-sent',
  templateUrl: './confirm-sent.component.html',
  styleUrls: ['./confirm-sent.component.scss']
})
export class ConfirmSentComponent extends NgbActiveModal implements OnInit {

  @Input() public data;

  constructor(
    public activeModal: NgbActiveModal
  ) {
    super();
  }

  ngOnInit() {
    if (!this.data) {
      this.data = {
        text: 'Are you sure you want to send this trip, including the information on safe and unsafe segments?',
        header: 'Trips'
      };
    }
  }

}
